import script from "./LoanReviewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LoanReviewPage.vue?vue&type=script&setup=true&lang=js"

import "./LoanReviewPage.vue?vue&type=style&index=0&id=3f3bb572&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f3bb572"]])

export default __exports__